import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { RiArrowDropDownLine } from "react-icons/ri";
import ModalWithSearchbar from "../../pages/modals/modalWithSearchbar";
import DateModal from "../../pages/modals/dateModal";
import "./DynamicFilter.css";
import { readableColor } from "polished";
import { colorBrandObject } from "../../../constants/brandings";

function DynamicFilter({
    filteredSchema,
    pspCodes,
    handleSearchbarModalData,
    handleDateModalData,
    value,
    useTabStyling,
    name,
}) {
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [openSearchbarModal, setOpenSearchbarModal] = useState(false);
    const [openDateModal, setOpenDateModal] = useState(false);
    const [withSearchModalData, setWithSearchModalData] = useState([]);
    const [dateModalData, setDateModalData] = useState([]);
    const [valueLengths, setValueLengths] = useState({});

    
    useEffect(() => {
        if (name) {
            const storedData = JSON.parse(localStorage.getItem(`${name}Filters`)) || [];
            const storedDate = JSON.parse(localStorage.getItem(`${name}Date`)) || [];
            setWithSearchModalData(storedData);
            setDateModalData(storedDate);
            handleSearchbarModalData(storedData);
            handleDateModalData(storedDate);
        }
    }, [name]);

    const handleFilterClick = (item) => {
        setSelectedFilter(item);
        if (item.type === "text") {
            setOpenSearchbarModal(true);
        } else if (item.type === "date") {
            setOpenDateModal(true);
        }
    };

    const handleSearchbarData = (data) => {
        setWithSearchModalData(data);
        handleSearchbarModalData(data);
        if (name) {
            localStorage.setItem(`${name}Filters`, JSON.stringify(data));
        }
    };

    const handleDateData = (data) => {
        setDateModalData(data);
        handleDateModalData(data);
        if (name) {
            localStorage.setItem(`${name}Date`, JSON.stringify(data));
        }
    };

    useEffect(() => {
        const newValueLengths = {};
        withSearchModalData.forEach(({ id, value }) => {
            newValueLengths[id] = value?.length || 0;
        });
        if (selectedFilter?.type == "date") {
            if (dateModalData?.selectedValue) {
                newValueLengths["date"] = 1;
            } else {
                newValueLengths["date"] = 0;
            }
        }else if(valueLengths.date) {
            newValueLengths["date"] = 1;
        }
        setValueLengths(newValueLengths);
    }, [withSearchModalData, dateModalData]);

    return (
        <div style={{ display: "flex", gap: "12px" }}>
            {filteredSchema.map((item, idx) => (
                <Button
                    key={idx}
                    onClick={() => handleFilterClick(item)}
                    endIcon={<RiArrowDropDownLine style={{ width: "20px", height: "20px", color: "black" }} />}
                    className={useTabStyling ? "filter-conatiner-with-tabs" : "filter-conatiner"}
                    focusRipple={false}
                    disableRipple={true}
                >
                    {valueLengths[item.id] > 0 && (
                        <div className="options-selected" style={{
                            color: readableColor(colorBrandObject?.secondaryButtonColor),
                            backgroundColor: colorBrandObject?.secondaryButtonColor
                        }}>
                            {valueLengths[item.id]}
                        </div>
                    )}
                    {item?.type =="date"  &&  valueLengths['date'] > 0 && <div className="options-selected" style={{
                            color: readableColor(colorBrandObject?.secondaryButtonColor),
                            backgroundColor: colorBrandObject?.secondaryButtonColor
                        }}>
                            {valueLengths["date"]}
                        </div>}
                    {item.label}
                </Button>
            ))}

            {selectedFilter?.type === "text" && (
                <ModalWithSearchbar
                    modalLabel={selectedFilter.label}
                    schemaId={selectedFilter.id}
                    modalListLabels={selectedFilter?.items}
                    multiselector={selectedFilter.multiselector}
                    displayLogo={selectedFilter.displayLogo}
                    uniqueType={selectedFilter.uniqueType}
                    showTitleType={selectedFilter.showTitleType}
                    value={value}
                    showFilterTitle={selectedFilter.filterTitle}
                    sendDataFromWithSearchbar={handleSearchbarData}
                    openModal={openSearchbarModal}
                    onClose={() => setOpenSearchbarModal(false)}
                    searchbarData={withSearchModalData}
                />
            )}

            {selectedFilter?.type === "date" && (
                <DateModal
                    sendDataFromDateModal={handleDateData}
                    openModal={openDateModal}
                    onClose={() => setOpenDateModal(false)}
                    presentData={dateModalData}
                />
            )}
        </div>
    );
}

export default DynamicFilter;
